import React from 'react';
// import { Link } from 'react-router-dom';
import { Oval } from 'react-loader-spinner'
// import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
const LoaderSpinner = props => {
    const { isrefresh } = props;
    return (
        (isrefresh === true) ?
            <div className='loaderSpinner'>
                <Oval
                    height="50"
                    width="50"
                    radius="9"
                    color="#00acac"
                    ariaLabel='three-dots-loading'
                    wrapperStyle
                    wrapperClass
                />
            </div>
            : <></>
    )

}

export default LoaderSpinner;